import {
  Control,
  FieldErrors,
  UseFormGetValues,
  UseFormSetError,
  UseFormSetValue,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SubHeader, withQueryState } from 'coreOld/components';
import { IDiscipline } from 'corporate/types';
import { IJob } from 'jobsOld/types';
import { DisciplineCheckboxes, DisciplineJobTable } from 'support/components';
import { supportRequestJobListPath } from 'support/routes/routePaths';
import { IRequest, IRequestJobs } from 'support/types';

import { RequestJobsDetailsWrapper } from './requestJobsDetailsStyle';

interface IProps {
  editMode: boolean;
  request: IRequest;
  requestJobs: IJob[];
  existingDisciplines?: { [disciplineId: number | string]: string };
  control: Control<IRequestJobs, object>;
  getValues: UseFormGetValues<IRequestJobs>;
  setValue: UseFormSetValue<IRequestJobs>;
  errors: FieldErrors<IRequestJobs>;
  setError: UseFormSetError<IRequestJobs>;
  onAddJob: (discipline: IDiscipline) => void;
  onRemoveJob: (discipline: IDiscipline) => void;
  goToRequestJobsList: () => void;
  onSubmit: () => void;
}

const RequestJobsDetailsView = ({
  editMode,
  request,
  requestJobs,
  existingDisciplines,
  control,
  getValues,
  setValue,
  errors,
  setError,
  onAddJob,
  onRemoveJob,
  goToRequestJobsList,
  onSubmit,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <RequestJobsDetailsWrapper>
      <SubHeader
        text={t('titleSupportRequestId', { id: request.id })}
        textUrl={editMode ? supportRequestJobListPath(request.id) : null}
        subText={editMode ? t('titleEditJobs') : t('titleAddJobs')}
        actionBtnText={editMode ? t('buttonLabelSaveJobs') : t('buttonLabelSubmitSupportRequest')}
        action={onSubmit}
        cancelAction={goToRequestJobsList}
        antentTexts={[
          t('titleTopBlockLeftSupportRequest', {
            projectName: request.projectName,
          }),
          t('titleTopBlockRightSupportRequest', {
            customerCompanyName: request.customerCompanyName,
            customerName: request.customerName,
          }),
        ]}
      />

      <DisciplineCheckboxes
        existingDisciplines={existingDisciplines}
        errors={errors}
        setError={setError}
        onAddJob={onAddJob}
        onRemoveJob={onRemoveJob}
      />

      <DisciplineJobTable
        requestJobs={requestJobs}
        control={control}
        getValues={getValues}
        setValue={setValue}
        errors={errors}
      />
    </RequestJobsDetailsWrapper>
  );
};

export default withQueryState(RequestJobsDetailsView);
